import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrowleft",
  "use": "arrowleft-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrowleft\"><title>arrowleft</title><path d=\"M13.359 7.313H4.39l3.375-3.25q.219-.203.219-.484t-.195-.492-.477-.211-.5.188L2.218 7.502q-.219.203-.219.492t.219.492l4.625 4.453q.203.188.469.188.297 0 .5-.219.203-.203.195-.484t-.211-.484L4.421 8.69h8.953q.266 0 .469-.188t.219-.453q.016-.297-.195-.516t-.508-.219z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/arrowleft.svg
// module id = 513
// module chunks = 0